import { configureStore } from '@reduxjs/toolkit'
import dataSlice from './dataslice';
import formSlice from './formslice';

const store = configureStore({
  reducer: {
    data: dataSlice,
    form: formSlice,
  },
})
export default store

export type AppDispatch = typeof store.dispatch;  // This ensures dispatch is typed correctly
export type RootState = ReturnType<typeof store.getState>;
